import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Match = types.compose(
  BaseEntity,
  types.model('Match', {
    constraintMatchId: types.identifierNumber,
    planningId: types.integer,
    description: types.maybe(types.string),
  }),
);
